const list = {
  login: "Login/login", //登录
  loginOut: "Login/loginOut", //退出登录
  registerUser: "Login/registerUser", //注册平台用户
  sendSmsCode: "Login/sendSmsCode", //发送短信验证码
};

export default list;
